let dateNow = Date.now();
export function generateCallBackId(): string {
    return (dateNow++).toString();
}
